import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environmentLoader } from './environments/environment-loader';
import { environment } from './environments/environment';

const cspNonceMeta = document.querySelector('meta[name="csp-nonce"]');
const nonce = cspNonceMeta?.getAttribute('content');

if (nonce) {
    const originalCreateElement = document.createElement;
    document.createElement = function (...args: any) {
        const el = originalCreateElement.apply(this, args);
        if (args[0]?.toLowerCase() === 'style') {
            el.setAttribute('nonce', nonce);
        }
        return el;
    };

    const observer = new MutationObserver((mutations) => {
        for (const m of mutations) {
            for (const node of Array.from(m.addedNodes)) {
                if (
                    node instanceof HTMLStyleElement &&
          !node.hasAttribute('nonce')
                ) {
                    node.setAttribute('nonce', nonce);
                }
            }
        }
    });

    observer.observe(document.documentElement, {
        childList: true,
        subtree: true
    });
}

environmentLoader.then((env) => {

    environment.environment = env.environment;
    environment.BACKEND_URL = env.BACKEND_URL;
    environment.RECAPTCHA_SITE_KEY = env.RECAPTCHA_SITE_KEY;

    platformBrowserDynamic().bootstrapModule(AppModule)
        .catch(err => console.error(err));
});
